import { LoadState } from "../../constants/enums";
import { IMasterForm, IMasterFormsState } from "./masterForms.types";

export const initialMasterForm: IMasterForm = {
  master_form_uuid: null,
  master_form_name: "",
  module_uuid: null,
  module_name: "",
  description: "",
  comment: "",
  status: "ACTIVE",
  created_by_uuid: "",
  created_by_name: "",
  modified_by_uuid: "",
  modified_by_name: "",
  create_ts: "",
  insert_ts: "",
};

export const initialMasterFormsState: IMasterFormsState = {
  list: {
    list: [],
    totalRecords: 0,
    loading: LoadState.NotLoaded,
    error: null,
  },
  form: {
    data: initialMasterForm,
    loading: LoadState.NotLoaded,
    error: null,
  },
};
